import { currentLocale, intlLocale } from "@ghezaa/ui";

// Built on first use, after initLocale() has settled the language for this page load.
let dateTime: Intl.DateTimeFormat | undefined;
let date: Intl.DateTimeFormat | undefined;

/** `12 Oct 2026, 14:30` — the house format. */
export function formatDateTime(iso: string | null | undefined): string {
  // Spelled out rather than dateStyle: Arabic's medium style is all digits (09/10/2026); this reads 9 أكتوبر 2026,
  // and an Egyptian clock has no leading zero (9:03 ص).
  dateTime ??= new Intl.DateTimeFormat(intlLocale(), { day: "numeric", month: "short", year: "numeric", hour: currentLocale() === "ar" ? "numeric" : "2-digit", minute: "2-digit" });
  return iso ? dateTime.format(new Date(iso)) : "—";
}

/** `12 Oct 2026` */
export function formatDate(iso: string | null | undefined): string {
  date ??= new Intl.DateTimeFormat(intlLocale(), { day: "numeric", month: "short", year: "numeric" });
  return iso ? date.format(new Date(iso)) : "—";
}
